import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import { getGatewayConfig, updateGatewayConfig } from '../core/subscriptionService';
import { useToast } from '../../components/Toats';

const providerOptions = [
  { value: 'ASAAS', label: 'Asaas' },
  { value: 'LEKKO_FINANCE', label: 'Lekko Finance (Em Breve)', isDisabled: true },
];

export const GatewayConfig: React.FC = () => {
  const { toggleToast } = useToast();
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [provider, setProvider] = useState(providerOptions[0]);
  const [apiKey, setApiKey] = useState('');
  const [isActive, setIsActive] = useState(false);
  const [webhookProvisioned, setWebhookProvisioned] = useState(false);

  useEffect(() => {
    getGatewayConfig().then((data) => {
      if (data) {
        const found = providerOptions.find((p) => p.value === data.provider);
        if (found) setProvider(found);
        setApiKey(data.api_key || '');
        setIsActive(data.is_active ?? false);
        setWebhookProvisioned(!!data.webhook_provisioned);
      }
      setLoading(false);
    }).catch(() => {
      setLoading(false);
    });
  }, []);

  const handleSave = () => {
    setSaving(true);
    updateGatewayConfig({
      provider: provider.value,
      api_key: apiKey || undefined,
      is_active: isActive,
    }).then(() => {
      setSaving(false);
      setWebhookProvisioned(true);
      toggleToast('Configuração de Gateway salva com sucesso!', 'success');
    }).catch((err: any) => {
      toggleToast(err?.response?.data?.message || err?.response?.data?.error || 'Erro ao salvar gateway.', 'error');
      setSaving(false);
    });
  };

  return (
    <div className='card mb-5 mb-xl-10'>
      <div className='card-header border-0 cursor-pointer' role='button' data-bs-toggle='collapse' data-bs-target='#kt_account_gateway_config'>
        <div className='card-title m-0'>
          <h3 className='fw-bolder m-0'>Gateway de Pagamento</h3>
        </div>
      </div>

      <div id='kt_account_gateway_config' className='collapse show'>
        <div className='card-body border-top p-9'>
          {loading ? (
            <div className='d-flex justify-content-center py-10'>
              <div className='spinner-border text-primary' role='status'>
                <span className='visually-hidden'>Carregando...</span>
              </div>
            </div>
          ) : (
            <>
              <div className='row mb-6'>
                <label className='col-lg-4 col-form-label required fw-bold fs-6'>Provedor</label>
                <div className='col-lg-8 fv-row'>
                  <Select
                    options={providerOptions}
                    value={provider}
                    onChange={(val) => setProvider(val as any)}
                    className="react-select-container"
                    classNamePrefix="react-select"
                    isSearchable={false}
                  />
                  <div className='form-text'>Selecione a processadora responsável pelas faturas de assinaturas.</div>
                </div>
              </div>

              <div className='row mb-6'>
                <label className='col-lg-4 col-form-label required fw-bold fs-6'>API Key (Access Token)</label>
                <div className='col-lg-8 fv-row'>
                  <input
                    type='password'
                    className='form-control form-control-lg form-control-solid'
                    placeholder='Insira a chave de API'
                    value={apiKey}
                    onChange={(e) => setApiKey(e.target.value)}
                  />
                </div>
              </div>

              <div className='row mb-6'>
                <label className='col-lg-4 col-form-label fw-bold fs-6'>Webhook</label>
                <div className='col-lg-8 fv-row'>
                  {webhookProvisioned ? (
                    <div className='notice d-flex bg-light-success rounded border-success border border-dashed p-4'>
                      <i className='bi bi-check-circle-fill fs-2tx text-success me-4'></i>
                      <div className='d-flex flex-stack flex-grow-1'>
                        <div className='fw-bold'>
                          <span className='text-gray-800 fw-bolder'>Webhook provisionado automaticamente</span>
                          <div className='fs-7 text-gray-600 mt-1'>
                            O webhook do Asaas foi configurado. As notificações de cobranças serão recebidas automaticamente.
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className='notice d-flex bg-light-warning rounded border-warning border border-dashed p-4'>
                      <i className='bi bi-exclamation-triangle fs-2tx text-warning me-4'></i>
                      <div className='d-flex flex-stack flex-grow-1'>
                        <div className='fw-bold'>
                          <span className='text-gray-800 fw-bolder'>Webhook não configurado</span>
                          <div className='fs-7 text-gray-600 mt-1'>
                            Salve o gateway com uma chave de API válida para provisionar o webhook automaticamente.
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              <div className='row mb-6'>
                <label className='col-lg-4 col-form-label fw-bold fs-6'>Ativo</label>
                <div className='col-lg-8 fv-row d-flex align-items-center'>
                  <div className='form-check form-check-solid form-switch form-check-custom fv-row'>
                    <input className='form-check-input w-45px h-30px' type='checkbox' checked={isActive} onChange={(e) => setIsActive(e.target.checked)} />
                    <label className='form-check-label'></label>
                  </div>
                  <span className='ms-3 text-muted fw-bold'>{isActive ? 'Gateway habilitado' : 'Gateway desabilitado'}</span>
                </div>
              </div>
            </>
          )}
        </div>

        <div className='card-footer d-flex justify-content-end py-6 px-9'>
          <button type='button' className='btn btn-primary' onClick={handleSave} disabled={saving || loading}>
            {saving ? <span className='spinner-border spinner-border-sm align-middle ms-2'></span> : 'Salvar Gateway'}
          </button>
        </div>
      </div>
    </div>
  );
};
